// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "product_stock".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "product_stock" table (1:1 with a DB row, on the wire). */
export const productStockAtomSchema = z.object({
    id: z.string(),
    productId: z.string(),
    locationId: z.string(),
    quantity: z.number(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=productStock.js.map